
import profile2 from '../assets/img/Me.jpeg';
import { useTheme, DARK, LIGHT } from '../context/ThemeContext';
import { FaPhone } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';



export const ContactInfo = () => {

    const { isDark } = useTheme();
    const t = isDark ? DARK : LIGHT;

    
    return (
    <div style={{
      background: t.bgAlt,
      border: `1px solid ${t.border}`,
      borderRadius: '12px',
      padding: '24px 20px',
      textAlign: 'center',
      transition: 'background 0.3s',
      height: '100%',           
  display: 'flex',          
  flexDirection: 'column', 
  justifyContent: 'center',
    }}>
      <div className="d-none d-md-block" style={{ marginBottom: '18px' }}>
        <img
          src={profile2}
          alt="Sandhya"
          style={{
            width: '150px', height: '150px',
            borderRadius: '50%', objectFit: 'cover',
            border: `2px solid ${t.border}`,
          }}
        />
      </div>
       <div style={{ fontSize: '13px', color: t.textSub, display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
          <span style={{
            width: '32px', height: '32px', borderRadius: '8px',
           // background: `${t.accentGreen}22`, 
            border: `1px solid ${t.accentGreen}44`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: t.accentGreen, fontSize: '15px', flexShrink: 0,
          }}>
            <FaPhone />
          </span>
          <span style={{ color: t.text }}>+1 (641) 233-9035</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
          <span style={{
            width: '32px', height: '32px', borderRadius: '8px',
           // background: `${t.accent}22`, 
            border: `1px solid ${t.accent}44`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: t.accent, fontSize: '15px', flexShrink: 0,
          }}>
            <MdEmail />
          </span>
          <a
            href="mailto:khinmyo.sandhya@gmail.com"
            style={{ color: t.accent, textDecoration: 'none' }}
            onMouseEnter={e => e.currentTarget.style.textDecoration = 'underline'}
            onMouseLeave={e => e.currentTarget.style.textDecoration = 'none'}
          >
            khinmyo.sandhya@gmail.com
          </a>
        </div>
      </div>
    </div>
  );
};